module.exports = __webpack_public_path__ + "static/media/all.9860436c.pred";